import { listAsConjunction, listAsDisjunction } from '../translations/list'

export const validFileExtensions = [
    'jpg',
    'jpeg',
    'gif',
    'png',
    'pdf',
    'txt',
    'docx',
    'xlsx',
    'pptx',
]

export const validMimeTypes = [
    'image/jpeg',
    'image/gif',
    'image/png',
    'application/pdf',
    'text/plain',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
]

export const validateDocumentMimeType = (type: string) => validMimeTypes.includes(type)

export const validFileExtensionsConjunction = () => listAsConjunction(validFileExtensions)

export const validFileExtensionsDisjunction = () => listAsDisjunction(validFileExtensions)
